<template>
  <div>
    <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <!-- <v-col cols="1">
          <v-btn icon dark disabled="">
            <v-icon size="30"> mdi-arrow-left-bold-box-outline </v-icon>
        </v-btn>-->
        <!-- </v-col> -->

        <v-col cols="3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="dialog = true"
                disabled
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-file-plus-outline</v-icon>
                <span class="lable_class">Add</span>
              </v-btn>
            </template>
            <span>Add</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on" disabled class="ml-5 header_btn">
                <v-icon size="28px">mdi-clipboard-edit-outline</v-icon>
                <span class="lable_class">Edit</span>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on" disabled class="ml-5 header_btn">
                <v-icon size="28px">mdi-eye-outline</v-icon>
                <span class="lable_class">View</span>
              </v-btn>
            </template>
            <span>View</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on" disabled class="ml-5 header_btn">
                <v-icon size="28px">mdi-delete-outline</v-icon>
                <span class="lable_class">Delete</span>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-col>
        <v-col cols="2">
          <v-btn icon small dark class="ml-5 header_btn" disabled>
            <v-icon size="28px">mdi-magnify</v-icon>
            <span class="lable_class">Search</span>
          </v-btn>
          <v-menu
            bottom
            :close-on-content-click="false"
            content-class="elevation-0"
            v-model="filter_menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark icon v-bind="attrs" v-on="on" class="ml-5 header_btn">
                <span class="lable_class">Filter</span>
                <v-badge
                  :content="filtersCount"
                  :value="filtersCount"
                  color="error"
                  overlap
                  size="30"
                >
                  <v-icon size="22px">mdi-filter-menu-outline</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-card tile max-width="310" class="mb-5 mr-5">
              <v-list class="filter-section-border">
                <v-subheader style="height: 32px" class="mt-2">
                  <v-row dense>
                    <v-col cols="5" v-if="pagination.filters.summery_of != '4'">
                      <v-autocomplete
                        dense
                        flat
                        :items="status"
                        outlined
                        label="Status"
                        hide-details
                        x-small
                        class="body-2"
                        placeholder=" "
                        v-model="pagination.filters.summery_of_status"
                      ></v-autocomplete>
                    </v-col>
                    <v-col :cols="pagination.filters.summery_of == '4' ? 10 : 5">
                      <v-autocomplete
                        dense
                        flat
                        :items="summery_of"
                        outlined
                        label="Report Of"
                        hide-details
                        class="body-2"
                        placeholder=" "
                        v-model="pagination.filters.summery_of"
                        item-disabled="disabled"
                        @change="excludeIncludeFromReport(1, 'All');pagination.page=1;itemsPerPage=25;pagination.filters.summery_of== '3' ? expence_filter_flag=false: '';pagination.filters.summery_of== '7' ? expence_filter_flag=true: ''; "
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="2" class="text-right">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            class="error"
                            @click="resetFilterData();"
                            icon
                            small
                          >
                            <v-icon size="20" class="white--text">mdi-filter-remove-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Reset</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-subheader>
                <v-list-item v-if="pagination.filters.summery_of != '4'">
                  <v-switch
                    class="pt-0 mt-2"
                    v-model="pagination.filters.transaction_only"
                    :label="
                      pagination.filters.transaction_only
                        ? 'Do not display zero value record'
                        : 'Display zero value record'
                    "
                    color="success"
                    dense
                    hide-details
                  ></v-switch>
                </v-list-item>
                <v-list-item v-if="
                    pagination.filters.summery_of == '2'">
                  <v-autocomplete
                    dense
                    flat
                    :items="project_work"
                    outlined
                    label="Project Type"
                    hide-details
                    small
                    class="body-2"
                    placeholder="All"
                    clearable
                    v-model="pagination.filters.project_work"
                  ></v-autocomplete>
                </v-list-item>
                <v-list-item
                  class="mt-2"
                  v-if="
                    pagination.filters.summery_of == '1' ||
                    pagination.filters.summery_of == '2'
                  "
                >
                  <v-autocomplete
                    dense
                    flat
                    :items="project_bank_list"
                    item-text="name"
                    item-value="content_id"
                    outlined
                    :label="
                      pagination.filters.summery_of == '1' ? 'Bank' : 'Project'
                    "
                    hide-details
                    class="body-2"
                    placeholder="All"
                    v-model="pagination.filters.vendor_bank_project"
                    clearable
                  ></v-autocomplete>
                </v-list-item>
                <v-list-item class="mt-2" v-if="pagination.filters.summery_of == '3'">
                  <v-autocomplete
                    dense
                    flat
                    :items="vendor_type_list"
                    item-text="vendor_type"
                    item-value="v_type_id"
                    outlined
                    label="Vendor Type"
                    hide-details
                    class="body-2"
                    placeholder="All"
                    v-model="pagination.filters.vendor_type"
                    clearable
                  ></v-autocomplete>
                </v-list-item>
                <v-list-item v-if="pagination.filters.summery_of == '3'">
                  <v-autocomplete
                    dense
                    flat
                    item-text="name"
                    item-value="content_id"
                    :items="vendor_list"
                    outlined
                    label="Vendor"
                    hide-details
                    class="body-2 focus-on-vendor-expence"
                    placeholder="All"
                    clearable
                    v-model="pagination.filters.vendor_bank_project"
                    @click="expence_filter_flag = false;"
                  >
                    <!-- <template v-slot:prepend-item>
                      <a
                        class="pl-4"
                        @click="
                          expence_filter_flag = false;
                          setFocus('focus-on-vendor-expence');
                        "
                        >Select Vendor</a
                      >
                      <v-divider></v-divider>
                    </template>-->
                  </v-autocomplete>
                </v-list-item>
                <v-list-item v-if="pagination.filters.summery_of == '7'">
                  <v-autocomplete
                    dense
                    flat
                    item-text="name"
                    item-value="content_id"
                    :items="expence_list"
                    outlined
                    label="Chart Of Account"
                    hide-details
                    class="body-2 focus-on-vendor-expence"
                    placeholder="All"
                    clearable
                    v-model="pagination.filters.vendor_bank_project"
                    @click="expence_filter_flag = true;"
                  >
                    <!-- <template v-slot:prepend-item>
                      <a
                        class="pl-4"
                        @click="
                          expence_filter_flag = true;
                          setFocus('focus-on-vendor-expence');
                        "
                        >Select Chart of Account</a
                      >
                      <v-divider></v-divider>
                    </template>-->
                  </v-autocomplete>
                </v-list-item>

                <v-list-item
                  :class="
                    pagination.filters.summery_of == '4' ? 'mt-2' : 'mt-0'
                  "
                >
                  <v-autocomplete
                    dense
                    flat
                    :items="date_filter"
                    outlined
                    label="Date Filter"
                    hide-details
                    class="body-2 mt-2"
                    placeholder="All"
                    v-model="pagination.filters.date_filter"
                    clearable
                    :menu-props="{
                      maxHeight: 340,
                    }"
                    @change="changeDateFilter()"
                  ></v-autocomplete>
                </v-list-item>
                <v-list-item v-if="pagination.filters.date_filter == '8'">
                  <v-menu
                    v-model="tran_start_date"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="pagination.filters.tran_start_date"
                        label="Start Date"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        dense
                        placeholder=" "
                        hide-details
                        outlined
                        clearable
                        @click:clear="disable_dates = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dateFormatted"
                      @input="
                        tran_start_date = false;
                        parseDate('tran_start_date');
                        changeDateFilter();
                      "
                      no-title
                      scrollable
                    ></v-date-picker>
                  </v-menu>

                  <v-menu
                    v-model="tran_end_date"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="pagination.filters.tran_end_date"
                        label="End Date"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        dense
                        placeholder=" "
                        hide-details
                        outlined
                        clearable
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dateFormatted"
                      @input="
                        tran_end_date = false;
                        parseDate('tran_end_date');
                        changeDateFilter();
                      "
                      no-title
                      scrollable
                      :min="disable_dates"
                    ></v-date-picker>
                  </v-menu>
                </v-list-item>
              </v-list>
              <v-card-title class="pa-0">
                <v-btn
                  fab
                  color="error"
                  x-small
                  absolute
                  @click="filter_menu = false"
                  class="custom-close-btn"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
            </v-card>
          </v-menu>
        </v-col>
        <v-col cols="3">
          <v-tooltip bottom v-if="pagination.filters.summery_of == '1'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                class="ml-7 header_btn"
                :disabled="selectedRows.length == 0"
                @click="excludeIncludeFromReport(0, 'bank')"
              >
                <v-icon size="28px">mdi-database-minus</v-icon>
                <span class="lable_class">Exclude</span>
              </v-btn>
            </template>
            <span>Exclude</span>
          </v-tooltip>
          <v-tooltip bottom v-if="pagination.filters.summery_of == '3'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                class="ml-7 header_btn"
                :disabled="selectedRows.length == 0"
                @click="excludeIncludeFromReport(0, 'vendor')"
              >
                <v-icon size="28px">mdi-database-minus</v-icon>
                <span class="lable_class">Exclude</span>
              </v-btn>
            </template>
            <span>Exclude</span>
          </v-tooltip>
          <v-tooltip bottom v-if="pagination.filters.summery_of == '2'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                class="ml-7 header_btn"
                :disabled="selectedRows.length == 0"
                @click="excludeIncludeFromReport(0, 'project')"
              >
                <v-icon size="28px">mdi-database-minus</v-icon>
                <span class="lable_class">Exclude</span>
              </v-btn>
            </template>
            <span>Exclude</span>
          </v-tooltip>
          <v-tooltip bottom v-if="pagination.filters.summery_of == '7'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                class="ml-7 header_btn"
                @click="excludeIncludeFromReport(0, 'bank')"
              >
                <v-icon size="28px">mdi-database-minus</v-icon>
                <span class="lable_class">Exclude</span>
              </v-btn>
            </template>
            <span>Exclude</span>
          </v-tooltip>
          <v-tooltip bottom v-if="pagination.filters.summery_of == '4'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                class="ml-7 header_btn"
                @click="excludeIncludeFromProfitLossReport(0)"
              >
                <v-icon size="28px">mdi-database-minus</v-icon>
                <span class="lable_class">Exclude</span>
              </v-btn>
            </template>
            <span>Exclude</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="openExcludedPopup()"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                class="ml-9 header_btn"
              >
                <v-icon size="28px">mdi-information-outline</v-icon>
                <span class="lable_class">Excluded P/C</span>
              </v-btn>
            </template>
            <span>Excluded Project and Chart of account</span>
          </v-tooltip>
        </v-col>
        <v-col cols="1">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on" class="ml-7 header_btn">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon size="328x" v-bind="attrs" v-on="on">mdi-printer</v-icon>
                    <span class="lable_class">Export report</span>
                  </template>
                  <span>Export report</span>
                </v-tooltip>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="getSummaryExcel()">
                <v-list-item-title>
                  <v-icon size="22">mdi-file-excel</v-icon>Detail
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="pagination.filters.summery_of == '4'"
                @click="getSummaryExcel('summary')"
              >
                <v-list-item-title>
                  <v-icon size="22">mdi-file-excel</v-icon>Summary
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="getSummaryPdf()">
                <v-list-item-title>
                  <v-icon size="22">mdi-file-pdf</v-icon>Detail
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="getSummaryPdf('summary')"
                v-if="pagination.filters.summery_of == '4'"
              >
                <v-list-item-title>
                  <v-icon size="22">mdi-file-pdf</v-icon>Summary
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-col cols="3" class="d-flex align-center justify-end">
          <span class="white--text font-weight-bold">
            Report Of
            <span v-if="pagination.filters.summery_of == '3'">Vendor</span>
            <span v-else-if="pagination.filters.summery_of == '7'">Chart Of Account</span>
            <span v-else-if="pagination.filters.summery_of == '2'">Project</span>
            <span v-else-if="pagination.filters.summery_of == '4'">Profit & Loss</span>
            <span v-else>Bank</span>
            <v-icon
              class="error--text ml-2"
              size="30"
              style="color:#ffffff !important"
              @click="logout()"
            >mdi-logout</v-icon>
          </span>
        </v-col>
      </v-row>
    </div>

    <div class="fixed-top-bar2 d-flex align-center">
      <v-row>
        <v-col cols="12">
          <span v-if="pagination.filters.summery_of != '4'" class="ml-2">
            Status:
            <b>{{ getStatus }}</b>
          </span>
          <span
            :class="pagination.filters.summery_of != '4' ? 'ml-10' : 'ml-2'"
            v-if="getSummarySelect"
          >
            Report Of:
            <b>{{ getSummarySelect }}</b>
          </span>
          <span class="ml-10" v-if="getContentName">
            <span v-if="pagination.filters.summery_of == '1'">Bank:</span>
            <span v-if="pagination.filters.summery_of == '2'">Project:</span>
            <span v-if="pagination.filters.summery_of == '3'">Vendor:</span>
            <span v-if="pagination.filters.summery_of == '7'">Chart Of Account:</span>
            <b>{{ getContentName }}</b>
          </span>
          <span class="ml-10" v-if="getVendorTypeName">
            Vendor Type:
            <b>{{ getVendorTypeName }}</b>
          </span>
          <span class="ml-10" v-if="display_start_date && display_end_date">
            Date Range:
            <b>{{ display_start_date }} - {{ display_end_date }}</b>
          </span>
          <span></span>
          <v-btn
            v-if="pagination.filters.summery_of == '4'"
            @click="expandAll"
            x-small
            class="ma-2 ml-10"
            color="primary"
          >Expand All</v-btn>
          <v-btn
            v-if="pagination.filters.summery_of == '4'"
            @click="collapseAll"
            x-small
            class="ma-2"
            color="secondary"
          >Collapse All</v-btn>
        </v-col>
      </v-row>
    </div>

    <v-overlay absolute :value="loading">
      <v-icon style="font-size: 80px">mdi-progress-clock mdi-spin</v-icon>
    </v-overlay>
    <v-card tile style="background: none" flat>
      <v-card-text class="pa-0" v-if="pagination.filters.summery_of == '4'">
        <v-row dense class="pa-0 ma-0">
          <v-col col="6" class="pa-0 ma-0 pr-1">
            <v-data-table
              :headers="headers3"
              class="elevation-1 rounded-0 my-transaction-table fix-table-layout fix-table-header fix-table-header-50"
              :search="search"
              :items="income_list.data"
              dense
              true
              :items-per-page="pagination.itemsPerPage"
              hide-default-footer
              :options.sync="pagination"
              :page.sync="pagination.page"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td width="4%">
                    <v-simple-checkbox
                      v-model="item.selected"
                      :ripple="false"
                      class="custom-simple-box"
                    ></v-simple-checkbox>
                  </td>
                  <td width="61%">
                    {{
                    item.bank_name ? item.bank_name : item.vendor_bank_name
                    }}
                  </td>
                  <td width="20%">
                    <div class="text-right">
                      <span
                        :class="{
                        'error--text': item.total < 0,
                        'primary--text': item.total > 0,
                      }"
                      >
                        <b>${{ getAmountFormat(item.total) }}</b>
                      </span>
                    </div>
                  </td>

                  <td width="15%" class="text-center">
                    <v-btn style="height: unset" icon :to="'/report_income/'+item.bank_id">
                      <v-icon>mdi-eye-outline</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      @click="item.expanded = !item.expanded"
                      :aria-expanded="item.expanded"
                      class="ml-2"
                    >
                      <v-icon>{{ item.expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                  </td>
                </tr>
                <template v-if="item.expanded">
                  <template v-for="(customer, cIndex) in item.customer_list">
                    <tr class="customer-row" :key="cIndex">
                      <td width="2%"></td>
                      <td width="4%">
                        <v-simple-checkbox
                          v-model="customer.selected"
                          :ripple="false"
                          class="custom-simple-box"
                        ></v-simple-checkbox>
                      </td>
                      <td
                        width="55%"
                        style="padding-left: 2rem;margin-left:5px"
                      >{{ customer.customer_name }}</td>
                      <td width="20%">
                        <div class="text-right">
                          <span
                            :class="{
                        'error--text': customer.total < 0,
                        'primary--text': customer.total > 0,
                      }"
                          >
                            <b>${{ getAmountFormat(customer.total) }}</b>
                          </span>
                        </div>
                      </td>
                      <td width="15%"></td>
                    </tr>
                    <template v-for="(project, pIndex) in customer.project_list">
                      <tr class="project-row" :key="pIndex">
                        <td width="10%"></td>
                        <td width="4%">
                          <v-simple-checkbox
                            v-model="project.selected"
                            :ripple="false"
                            class="custom-simple-box"
                          ></v-simple-checkbox>
                        </td>
                        <td
                          width="70%"
                          style="padding-left: 2rem;margin-left:5px"
                        >{{ project.p_name }}</td>
                        <td width="20%">
                          <div class="text-right">
                            <span
                              :class="{
                        'error--text': project.total < 0,
                        'primary--text': project.total > 0,
                      }"
                            >${{ getAmountFormat(project.total) }}</span>
                          </div>
                        </td>
                        <td width="15%"></td>
                      </tr>
                    </template>
                  </template>
                </template>
              </template>
              <template v-slot:body.append>
                <tr class="grey lighten-1 fix-bottom-bar pr-3">
                  <td colspan="2">
                    <span style="margin-left: 350px;">
                      <span>
                        Total Income:
                        <span
                          :class="(total_credit < 0)? 'red': 'green'"
                          class="white--text"
                        >${{ getAmountFormat(total_credit) }}</span>
                      </span>

                      <span style="margin-left: 20px;">
                        Total Expense:
                        <span
                          :class="(total_debit < 0)? 'red': 'green'"
                          class="white--text"
                        >${{ getAmountFormat(total_debit) }}</span>
                      </span>

                      <span style="margin-left: 20px;">
                        {{(total_balance > 0) ? 'Profit' :'Loss'}}:
                        <span
                          :class="(total_balance < 0)? 'red': 'green'"
                          class="white--text"
                        >${{ getAmountFormat(total_balance) }}</span>
                      </span>
                      <span style="margin-left: 20px;">
                        Per:
                        <span
                          :class="(total_balance < 0)? 'red': 'green'"
                          class="white--text"
                        >{{per}}%</span>
                      </span>
                    </span>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <div class="v-data-footer custom-pagination fix-footer-bar">
              <v-row dense>
                <v-col cols="3" class="d-flex align-center justify-start">
                  <span>Total Record: {{ income_list.total }}</span>
                  <div class="v-data-footer__select pl-5">
                    Rows per page:
                    <v-select
                      v-model="pagination.itemsPerPage"
                      :items="pagination_settings.perPageList"
                      dense
                      hide-details
                    ></v-select>
                  </div>
                </v-col>
                <v-col cols="3" class="d-flex align-center justify-start">
                  <v-pagination
                    class="d-flex align-center justify-start"
                    v-model="pagination.page"
                    :length="income_list.last_page"
                    total-visible="10"
                  ></v-pagination>
                </v-col>

                <v-col cols="3" class="d-flex align-center justify-start">
                  <span>Total Record: {{ expense_list.total }}</span>
                  <div class="v-data-footer__select pl-5">
                    Rows per page:
                    <v-select
                      v-model="pagination1.itemsPerPage"
                      :items="pagination_settings.perPageList"
                      dense
                      hide-details
                    ></v-select>
                  </div>
                </v-col>
                <v-col cols="3" class="d-flex align-center justify-start">
                  <v-pagination
                    class="d-flex align-center justify-start"
                    v-model="pagination1.page"
                    :length="expense_list.last_page"
                    total-visible="10"
                  ></v-pagination>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col col="6" class="pa-0 ma-0 pl-1">
            <v-data-table
              :headers="headers4"
              class="elevation-1 rounded-0 my-transaction-table fix-table-layout fix-table-header fix-table-header-50"
              :search="search"
              :items="expense_list.data"
              dense
              calculate-widths:
              true
              :items-per-page="pagination1.itemsPerPage"
              hide-default-footer
              :options.sync="pagination1"
              :page.sync="pagination1.page"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td width="4%">
                    <v-simple-checkbox
                      v-model="item.selected"
                      :ripple="false"
                      class="custom-simple-box"
                    ></v-simple-checkbox>
                  </td>
                  <td width="50%">
                    {{
                    item.bank_name ? item.bank_name : item.vendor_bank_name
                    }}
                  </td>
                  <td width="20%" class="text-right">
                    <span
                      :class="{
                        'error--text': item.total < 0,
                        'primary--text': item.total > 0,
                      }"
                    >
                      <b>${{ getAmountFormat(item.total) }}</b>
                    </span>
                  </td>
                  <td width="24%" class="text-center">
                    <v-btn style="height: unset" icon :to="redirectTo(item)">
                      <v-icon>mdi-eye-outline</v-icon>
                    </v-btn>
                    <span
                      class="ml-3"
                    >{{total_credit!=0 ? ((-item.total*100)/total_credit).toFixed(2)+ "%" : ""}}</span>
                    <v-btn
                      icon
                      @click="item.expanded = !item.expanded"
                      :aria-expanded="item.expanded"
                      class="ml-2"
                    >
                      <v-icon>{{ item.expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                  </td>
                </tr>
                <template v-if="item.expanded">
                  <template v-for="(vendor, cIndex) in item.vendor_list">
                    <tr class="customer-row" :key="cIndex">
                      <td width="2%"></td>
                      <td width="4%">
                        <v-simple-checkbox
                          v-model="vendor.selected"
                          :ripple="false"
                          class="custom-simple-box"
                          :disabled="vendor.expence==true"
                        ></v-simple-checkbox>
                      </td>
                      <td
                        width="36%"
                        style="padding-left: 2rem;margin-left:5px"
                      >{{ vendor.bank_name ? vendor.bank_name: vendor.v_name }}</td>
                      <td width="20%">
                        <div class="text-right">
                          <span
                            :class="{
                        'error--text': vendor.total < 0,
                        'primary--text': vendor.total > 0,
                      }"
                          >${{ getAmountFormat(vendor.total) }}</span>
                        </div>
                      </td>
                      <td width="20%"></td>
                    </tr>
                  </template>
                </template>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text class="pa-0 mx-auto" v-else-if="pagination.filters.summery_of == '2'">
        <v-data-table
          :headers="headers"
          class="elevation-1 rounded-0 my-transaction-table fix-table-layout fix-table-header"
          item-key="user_id"
          :search="search"
          :items="items.data"
          mobile-breakpoint="50"
          dense
          :items-per-page="pagination.itemsPerPage"
          hide-default-footer
          :options.sync="pagination"
          :page.sync="pagination.page"
        >
          <template v-slot:header.select_all>
            <v-simple-checkbox
              v-model="select_all_checkbox"
              @input="changeSelectAll()"
              color="white"
              :ripple="false"
              class="select-all-checkbox custom-simple-box white_box"
              style="color:#ffffff !important;"
            ></v-simple-checkbox>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td width="4%">
                <v-simple-checkbox
                  v-model="item.selected"
                  :ripple="false"
                  class="custom-simple-box"
                ></v-simple-checkbox>
              </td>
              <td width="15%" class="pl-2">{{ item.name }}</td>
              <td width="10%" class="pl-2 text-right">
                <span
                  style="cursor:pointer;text-decoration-line: underline;"
                  @click="redirectToInvoice(item.content_id)"
                >{{ item.invoice_amount != 0 ? item.invoice_amount : '' }}</span>
              </td>
              <td
                width="10%"
                class="pl-2 text-right"
              >{{ item.invoice_amount !=0 ? (item.balance_due != 0 ? item.balance_due : '') :'' }}</td>
              <td width="15%">
                <div
                  class="text-right"
                  v-if="
                    item.display_opending_balance &&
                    item.display_opending_balance != '0.00'
                  "
                >
                  <span
                    :class="{
                      'error--text': item.display_opending_balance < 0,
                      'primary--text': item.display_opending_balance > 0,
                    }"
                  >${{ getAmountFormat(item.display_opending_balance) }}</span>
                </div>
              </td>
              <td width="12%">
                <div class="text-right">
                  <span
                    v-if="item.credit != '0.00'"
                    :class="(item.credit < 0)? 'error--text': 'primary--text'"
                  >${{ getAmountFormat(item.credit) }}</span>
                </div>
              </td>
              <td width="12%">
                <div class="text-right">
                  <span
                    v-if="item.debit != '0.00'"
                    :class="(item.debit < 0)? 'error--text': 'primary--text'"
                  >${{ getAmountFormat(item.debit) }}</span>
                </div>
              </td>
              <td width="12%">
                <div class="text-right">
                  <span
                    :class="{
                      'error--text': item.balance < 0,
                      'primary--text': item.balance > 0,
                    }"
                  >${{ getAmountFormat(item.balance) }}</span>
                </div>
              </td>
              <td width="4%">
                <v-btn style="height: unset" icon :to="RedirectLink(item)">
                  <v-icon>mdi-eye-outline</v-icon>
                </v-btn>
              </td>
              <td width="4%" class="text-right">
                <span
                  :class="{
                      'error--text': item.balance < 0,
                      'primary--text': item.balance > 0,
                    }"
                >{{(item.per).toFixed()}}%</span>
              </td>
              <td width="5%"></td>
            </tr>
          </template>
          <template v-slot:body.append>
            <tr class="grey lighten-1 fix-bottom-bar pr-3">
              <td colspan="2" width="34%" class="text-right">Total:</td>
              <td width="12%">
                <div class="text-right">
                  <span
                    v-if="total_credit != '0.00'"
                    class="white--text green"
                  >${{ getAmountFormat(total_credit) }}</span>
                </div>
              </td>
              <td width="12%">
                <div class="text-right">
                  <span
                    v-if="total_debit != '0.00'"
                    class="white--text red"
                  >${{ getAmountFormat(total_debit) }}</span>
                </div>
              </td>
              <td width="12%">
                <div class="text-right">
                  <span
                    :class="{
                      red: total_balance < 0,
                      green: total_balance > 0,
                    }"
                    class="white--text"
                  >${{ getAmountFormat(total_balance) }}</span>
                </div>
              </td>
              <td colspan="2" width="30%"></td>
            </tr>
          </template>
        </v-data-table>
        <div class="v-data-footer custom-pagination fix-footer-bar">
          <v-row dense>
            <v-col cols="6" class="d-flex align-center justify-end">
              <span>Total Record: {{ items.total }}</span>
              <div class="v-data-footer__select pl-5">
                Rows per page:
                <v-select
                  v-model="pagination.itemsPerPage"
                  :items="pagination_settings.perPageList"
                  dense
                  hide-details
                ></v-select>
              </div>
            </v-col>
            <v-col cols="6" class="d-flex align-center justify-start">
              <v-pagination
                class="d-flex align-center justify-start"
                v-model="pagination.page"
                :length="items.last_page"
                total-visible="10"
              ></v-pagination>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-card-text class="pa-0 mx-auto" v-else>
        <v-data-table
          :headers="headersbv"
          class="elevation-1 rounded-0 my-transaction-table fix-table-layout fix-table-header"
          item-key="user_id"
          :search="search"
          :items="items.data"
          mobile-breakpoint="50"
          dense
          :items-per-page="pagination.itemsPerPage"
          hide-default-footer
          :options.sync="pagination"
          :page.sync="pagination.page"
        >
          <template v-slot:header.select_all>
            <v-simple-checkbox
              v-model="select_all_vendor_checkbox"
              @input="changeSelectAllVendor()"
              color="white"
              :ripple="false"
              class="select-all-checkbox custom-simple-box white_box"
              style="color:#ffffff !important;"
            ></v-simple-checkbox>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td width="4%">
                <v-simple-checkbox
                  v-model="item.selected"
                  :ripple="false"
                  class="custom-simple-box"
                ></v-simple-checkbox>
              </td>
              <td width="22%" class="pl-2">{{ item.name }}</td>
              <td width="12%">
                <div
                  class="text-right"
                  v-if="
                    item.display_opending_balance &&
                    item.display_opending_balance != '0.00' && pagination.filters.date_filter !=undefined && pagination.filters.date_filter !=''
                  "
                >
                  <span
                    :class="{
                      'error--text': item.display_opending_balance < 0,
                      'primary--text': item.display_opending_balance > 0,
                    }"
                  >${{ getAmountFormat(item.display_opending_balance) }}</span>
                </div>
              </td>
              <td width="12%">
                <div class="text-right">
                  <span
                    v-if="item.credit != '0.00'"
                    class="primary--text"
                  >${{ getAmountFormat(item.credit) }}</span>
                </div>
              </td>
              <td width="12%">
                <div class="text-right">
                  <span
                    v-if="item.debit != '0.00'"
                    class="error--text"
                  >${{ getAmountFormat(item.debit) }}</span>
                </div>
              </td>
              <td width="12%">
                <div class="text-right">
                  <span
                    :class="{
                      'error--text': item.balance < 0,
                      'primary--text': item.balance > 0,
                    }"
                  >${{ getAmountFormat(item.balance) }}</span>
                </div>
              </td>
              <td width="4%">
                <v-btn style="height: unset" icon :to="RedirectLink(item)">
                  <v-icon>mdi-eye-outline</v-icon>
                </v-btn>
              </td>
              <td width="22%"></td>
            </tr>
          </template>

          <template v-slot:body.append>
            <tr class="grey lighten-1 fix-bottom-bar pr-3">
              <td colspan="2" width="34%" class="text-right">Total:</td>
              <td width="12%">
                <div class="text-right">
                  <span
                    v-if="total_credit != '0.00'"
                    class="white--text green"
                  >${{ getAmountFormat(total_credit) }}</span>
                </div>
              </td>
              <td width="12%">
                <div class="text-right">
                  <span
                    v-if="total_debit != '0.00'"
                    class="white--text red"
                  >${{ getAmountFormat(total_debit) }}</span>
                </div>
              </td>
              <td width="12%">
                <div class="text-right">
                  <span
                    :class="{
                      red: total_balance < 0,
                      green: total_balance > 0,
                    }"
                    class="white--text"
                  >${{ getAmountFormat(total_balance) }}</span>
                </div>
              </td>
              <td colspan="2" width="30%"></td>
            </tr>
          </template>
        </v-data-table>
        <div class="v-data-footer custom-pagination fix-footer-bar">
          <v-row dense>
            <v-col cols="6" class="d-flex align-center justify-end">
              <span>Total Record: {{ items.total }}</span>
              <div class="v-data-footer__select pl-5">
                Rows per page:
                <v-select
                  v-model="pagination.itemsPerPage"
                  :items="pagination_settings.perPageList"
                  dense
                  hide-details
                ></v-select>
              </div>
            </v-col>
            <v-col cols="6" class="d-flex align-center justify-start">
              <v-pagination
                class="d-flex align-center justify-start"
                v-model="pagination.page"
                :length="items.last_page"
                total-visible="10"
              ></v-pagination>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
    <ExcludeReport
      :exclude_report="exclude_report"
      :exclude_for="exclude_for"
      @getProjectReportData="getSummary(false);"
      @close_popup="exclude_report = false;"
    />
    <v-dialog v-model="confirm_date_dialog" width="430px">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>
          <p>Opening balance date is greater than start date.Do you want to generate a report?</p>
          <b class="mb-2">Date range : {{actual_start_date}} to {{change_end_date}}</b>
          <template>
            <v-data-table
              :headers="headers_outRange"
              class="elevation-1"
              :items="outofdate_bank_list.data"
            ></v-data-table>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td width="50%">
                {{
                item
                }}
              </td>
              <td width="50%" class="text-right">
                {{
                item
                }}
              </td>
            </tr>
          </template>
        </v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="CloseOpeningDialog()">Cancel</v-btn>
          <v-btn color="red darken-1" text @click="ChangeStartdate()">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "../../plugins/axios";
import { mapMutations } from "vuex";

import {
  parseParams,
  setDateFilterValue,
  getDateFilterValue,
  resetDateFilterValue,
  logout
} from "../../plugins/helper";
import ExcludeReport from "../Transaction/ExcludeReport.vue";
import { mapState } from "vuex";
export default {
  name: "UsersList",
  data() {
    return {
      loading: false,
      search: "",
      items: {
        data: []
      },
      filter_menu: false,
      total_balance: 0,
      total_credit: 0,
      total_debit: 0,
      per: 0,
      filter_start_date: null,
      filter_start_end: null,
      project_bank_list: [],
      expence_filter_flag: false,
      exclude_report: false,
      exclude_for: "profit_loss",
      select_all_checkbox: false,
      select_all_vendor_checkbox: false,
      vendor_list: [],
      expence_list: [],
      project_work: [
        { text: "All", value: "" },
        { text: "New Construction", value: "new_construction" },
        { text: "Remodeling", value: "remodeling" },
        { text: "General Invoice", value: "retail_sales" },
        { text: "Counter Tops", value: "counter_tops" }
      ],
      income_list: {
        data: []
      },
      expense_list: {
        data: []
      },
      outofdate_bank_list: {
        data: []
      },
      vendor_type_list: [],
      display_start_date: getDateFilterValue("display_start_date"),
      display_end_date: getDateFilterValue("display_end_date"),
      headersbv: [
        {
          value: "select_all",
          text: "",
          width: "4%",
          class: "pl-2",
          sortable: false
        },
        {
          value: "name",
          text: "Name",
          sortable: false,
          width: "22%",
          class: "pl-2"
        },
        {
          value: "",
          text: "Opening Bal.",
          sortable: false,
          align: "right",
          width: "12%"
        },
        {
          value: "credit",
          text: "Credit",
          sortable: false,
          align: "right",
          width: "12%"
        },
        {
          value: "debit",
          text: "Debit",
          sortable: false,
          align: "right",
          width: "12%"
        },
        {
          value: "balance",
          text: "Balance",
          sortable: false,
          align: "right",
          width: "12%"
        },
        { value: "", text: "", sortable: false, width: "4%" },
        { value: "", text: "", sortable: false, width: "22%" }
      ],
      headers: [
        {
          value: "select_all",
          text: "",
          width: "4%",
          class: "pl-2",
          sortable: false
        },
        {
          value: "name",
          text: "Name",
          sortable: false,
          width: "15%",
          class: "pl-2"
        },
        {
          value: "invoice_amount",
          text: "Invoice Amt.",
          sortable: false,
          width: "10%",
          class: "pl-2",
          align: "right"
        },
        {
          value: "balance_due",
          text: "Balance Due",
          sortable: false,
          width: "10%",
          align: "right"
        },
        {
          value: "",
          text: "Opening Bal. (P&L)",
          sortable: false,
          align: "right",
          width: "15%"
        },
        {
          value: "credit",
          text: "Income",
          sortable: false,
          align: "right",
          width: "12%"
        },
        {
          value: "debit",
          text: "Expense",
          sortable: false,
          align: "right",
          width: "12%"
        },
        {
          value: "balance",
          text: "P&L",
          sortable: false,
          align: "right",
          width: "12%"
        },
        { value: "", text: "", sortable: false, width: "4%", align: "right" },
        { value: "", text: "", sortable: false, width: "4%", align: "right" },
        { value: "", text: "", sortable: false, width: "5%", align: "right" }
      ],
      headers2: [
        {
          value: "income",
          text: "Income",
          sortable: false,
          width: "12%"
        },
        {
          value: "expence",
          text: "Expense",
          sortable: false,
          width: "12%"
        },
        {
          value: "balance",
          text: "Profit/Loss",
          sortable: false,
          width: "12%"
        },
        { value: "", text: "", sortable: false, align: "right", width: "64%" }
      ],
      headers3: [
        {
          value: "bank_name",
          text: "Income",
          sortable: false,
          width: "70%"
        },
        {
          value: "total",
          text: "Total",
          sortable: false,
          align: "right",
          width: "20%"
        },
        {
          value: "action",
          text: "",
          sortable: false,
          align: "center",
          width: "10%"
        }
      ],
      headers4: [
        {
          value: "bank_name",
          text: "Expense",
          sortable: false,
          width: "65%"
        },
        {
          value: "total",
          text: "Total",
          sortable: false,
          align: "right",
          width: "20%"
        },
        {
          value: "action",
          text: "",
          sortable: false,
          align: "center",
          width: "15%"
        }
      ],
      headers_outRange: [
        {
          value: "name",
          text: "Bank",
          sortable: false,
          width: "50%"
        },
        {
          value: "date_of_opening_balance",
          text: "Opening Balance Date",
          sortable: false,
          width: "50%"
        }
      ],
      dateFormatted: null,
      tran_start_date: false,
      tran_end_date: false,
      start_date_formate: null,
      end_date_formate: null,
      confirm_date_dialog: false,
      change_start_date: "",
      change_end_date: "",
      actual_start_date: "",
      summery_of: [
        { text: "Bank", value: "1" },
        { text: "Project", value: "2" },
        { text: "Vendor", value: "3" },
        { text: "Chart of Account", value: "7" },
        { text: "Profit & Loss", value: "4" },
        // { text: "Trial Balance", value: "5", disabled: true },
        { text: "Balance Sheet", value: "6", disabled: true }
      ],
      status: [
        { text: "All", value: "" },
        { text: "Active", value: "1" },
        { text: "Inactive", value: "0" }
      ],
      date_filter: [
        // { text: "Today", value: "1" },
        { text: "All", value: "" },
        { text: "Custom", value: "8" },
        { text: "12 Month", value: "9" },
        { text: "24 Month", value: "10" },
        // { text: "Last 7 Days", value: "2" },
        // { text: "Last 30 Days", value: "3" },
        // { text: "Last 60 Days", value: "4" },
        // { text: "Last 90 Days", value: "5" },
        { text: "This Financial Year", value: "6" },
        { text: "Last Financial Year", value: "7" }
      ],
      pagination: {
        itemsPerPage: -1,
        sortBy: ["trans_code"],
        page: 1,
        filters: {
          transaction_only: false,
          // tran_start_date: this.getFormatedDate('start_date'),
          // tran_end_date: this.getFormatedDate('end_date'),
          tran_start_date: getDateFilterValue("start_date"),
          tran_end_date: getDateFilterValue("end_date"),
          summery_of: this.$route.params.type,
          summery_of_status: "1",
          // date_filter: "",
          date_filter: getDateFilterValue("date_filter"),
          vendor_bank_project: "",
          vendor_type: "",
          project_work: ""
        }
      },
      pagination1: {
        itemsPerPage: -1,
        sortBy: ["trans_code"],
        page: 1,
        filters: {
          transaction_only: false,
          // tran_start_date: this.getFormatedDate('start_date'),
          // tran_end_date: this.getFormatedDate('end_date'),
          tran_start_date: getDateFilterValue("start_date"),
          tran_end_date: getDateFilterValue("end_date"),
          summery_of: this.$route.params.type,
          summery_of_status: "1",
          //date_filter: (this.$route.params.start_date && this.$route.params.end_date)?"8":"",
          date_filter: getDateFilterValue("date_filter"),
          vendor_bank_project: "",
          vendor_type: ""
        }
      }
    };
  },
  components: {
    ExcludeReport
  },
  computed: {
    ...mapState("utils", ["pagination_settings"]),
    selectedRows() {
      return this.items.data.filter(function(item) {
        return item.selected == true;
      });
    },
    selectedIncomeRows() {
      return this.income_list?.data?.filter(function(item) {
        return item.selected == true;
      });
    },
    selectedCustomerRows() {
      return this.income_list.data.flatMap(item =>
        item.customer_list
          ? item.customer_list.filter(customer => customer.selected)
          : []
      );
    },
    selectedProjectRows() {
      return (this.income_list?.data || []).flatMap(incomeItem =>
        (incomeItem.customer_list || []).flatMap(customer =>
          (customer.project_list || []).filter(project => project.selected)
        )
      );
    },
    selectedExpenseRows() {
      return this.expense_list?.data?.filter(function(item) {
        return item.selected == true;
      });
    },
    selectedVendorRows() {
      return this.expense_list.data.flatMap(item =>
        item.vendor_list
          ? item.vendor_list.filter(
              vendor => vendor.selected && vendor.expence == false
            )
          : []
      );
    },
    getVendorTypeName() {
      let data = "";
      this.vendor_type_list.filter(item => {
        if (this.pagination.filters.vendor_type == item.v_type_id) {
          data = item.vendor_type;
        }
      });
      return data;
    },
    getContentName() {
      let data = "";
      if (
        this.pagination.filters.summery_of == "3" ||
        this.pagination.filters.summery_of == "7"
      ) {
        if (this.expence_filter_flag) {
          this.expence_list.filter(item => {
            if (
              this.pagination.filters.vendor_bank_project == item.content_id
            ) {
              data = item.name;
            }
          });
        } else {
          this.vendor_list.filter(item => {
            if (
              this.pagination.filters.vendor_bank_project == item.content_id
            ) {
              data = item.name;
            }
          });
        }
      } else {
        this.project_bank_list.filter(item => {
          if (this.pagination.filters.vendor_bank_project == item.content_id) {
            data = item.name;
          }
        });
      }
      return data;
    },
    getSummarySelect() {
      let data = "";
      this.summery_of.filter(item => {
        if (this.pagination.filters.summery_of == item.value) {
          data = item.text;
        }
      });
      return data;
    },
    getStatus() {
      let status = "All";
      this.status.filter(item => {
        if (item.value == this.pagination.filters.summery_of_status) {
          status = item.text;
        }
      });
      return status;
    },
    pageData() {
      let paginationData = this.pagination;
      return paginationData;
    },
    pageData1() {
      let paginationData1 = this.pagination1;
      return paginationData1;
    },
    filtersCount() {
      let count = 0;
      for (var key in this.pagination.filters) {
        if (
          this.pagination.filters[key] &&
          key != "tran_start_date" &&
          key != "tran_end_date"
        ) {
          count++;
        }
      }
      if (
        this.pagination.filters.tran_start_date &&
        this.pagination.filters.tran_end_date
      ) {
        count++;
      }
      if (count == 2) {
        return "D";
      } else {
        return count;
      }
    }
  },
  watch: {
    pagination: {
      handler: function() {
        this.getSummary(false);
        this.getSummaryExpense(false);
      },
      deep: true
    },
    pagination1: {
      handler: function() {
        this.getSummaryExpense(false);
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations("transaction", ["setTransactionData"]),
    ...mapMutations("utils", ["setAlert"]),
    expandAll() {
      this.income_list.data = this.income_list.data.map(item => ({
        ...item,
        expanded: true
      }));
      this.expense_list.data = this.expense_list.data.map(item => ({
        ...item,
        expanded: true
      }));
    },
    // Collapse all rows
    collapseAll() {
      this.income_list.data = this.income_list.data.map(item => ({
        ...item,
        expanded: false
      }));

      this.expense_list.data = this.expense_list.data.map(item => ({
        ...item,
        expanded: false
      }));
    },
    redirectTo(item) {
      if (item.bank_name) {
        return "/report_expense/" + item.bank_id;
      } else {
        return "/report_expense/" + item.vendor_bank_id;
      }
    },
    changeSelectAll() {
      let _self = this;
      if (_self.select_all_checkbox) {
        _self.items.data = _self.items.data.map(function(item) {
          item.selected = true;
          return item;
        });
      } else {
        _self.items.data = _self.items.data.map(function(item) {
          item.selected = false;
          return item;
        });
      }
    },
    changeSelectAllVendor() {
      let _self = this;
      if (_self.select_all_vendor_checkbox) {
        _self.items.data = _self.items.data.map(function(item) {
          item.selected = true;
          return item;
        });
      } else {
        _self.items.data = _self.items.data.map(function(item) {
          item.selected = false;
          return item;
        });
      }
    },
    redirectToInvoice(project_id) {
      let _self = this;
      _self.setTransactionData({ key: "is_from_dashboard", value: true });
      _self.setTransactionData({ key: "co_project_id", value: project_id });
      _self.$router.push("/transaction");
    },
    changeDateFilter() {
      setDateFilterValue(
        this.pagination.filters.date_filter,
        this.pagination.filters.tran_start_date,
        this.pagination.filters.tran_end_date
      );
      this.display_start_date = getDateFilterValue("display_start_date");
      this.display_end_date = getDateFilterValue("display_end_date");
    },
    getFormatedDate(field_name) {
      let date = "";
      let year = "";
      let month = "";
      let day = "";
      if (this.$route.params.start_date && this.$route.params.start_date) {
        if (field_name == "start_date") {
          [year, month, day] = this.$route.params.start_date.split("-");
        } else {
          [year, month, day] = this.$route.params.end_date.split("-");
        }
        date = `${month.padStart(2, "0")}/${day.padStart(2, "0")}/${year}`;
      }
      return date;
    },
    setFocus(className) {
      document.querySelectorAll("." + className + " input")[0].focus();
    },
    getAmountFormat(value) {
      if (value) {
        value = value.toString();
        return value.replace("-", "");
      } else {
        return 0;
      }
    },
    parseDate(key) {
      if (key == "tran_start_date") {
        if (this.dateFormatted) {
          this.disable_dates = this.dateFormatted;
        } else {
          this.disable_dates = null;
        }
      }
      const [year, month, day] = this.dateFormatted.split("-");
      this.pagination.filters[key] = `${month.padStart(2, "0")}/${day.padStart(
        2,
        "0"
      )}/${year}`;
      this.pagination1.filters[key] = `${month.padStart(2, "0")}/${day.padStart(
        2,
        "0"
      )}/${year}`;
    },

    resetFilterData() {
      resetDateFilterValue();
      this.resetFilter();
    },
    resetFilter() {
      // resetDateFilterValue();
      //this.pagination.filters.tran_start_date = this.getFormatedDate('start_date'),
      //this.pagination.filters.tran_end_date = this.getFormatedDate('end_date'),
      (this.pagination.filters.tran_start_date = ""),
        (this.pagination.filters.tran_end_date = ""),
        (this.pagination.filters.date_filter = "");
      this.pagination.filters.vendor_bank_project = "";
      this.pagination.filters.vendor_type = "";
      this.pagination.filters.summery_of = this.$route.params.type;
      this.pagination.filters.summery_of_status = "1";
      this.pagination.filters.transaction_only = false;
      this.display_start_date = getDateFilterValue("display_start_date");
      this.display_end_date = getDateFilterValue("display_end_date");
      this.getSummary(false);
      this.getSummaryExpense(false);
    },

    getSummaryExcel(type) {
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      let url = parseParams(this.pageData);
      url = url + "&itemsPerPage=-1";

      if (this.pageData.filters["summery_of"] == "4") {
        window.location.href =
          process.env.VUE_APP_BASEURL +
          "/generate_get_profit_loss_data_final_pdf?is_pdf=true&is_excel=true&user_id=" +
          localStorage.getItem("user_id") +
          "&company_id=" +
          company_data.company_id +
          "&type=" +
          type +
          "&" +
          url;
      } else {
        window.location.href =
          process.env.VUE_APP_BASEURL +
          "/transaction_summary_pdf?is_pdf=true&is_excel=true&user_id=" +
          localStorage.getItem("user_id") +
          "&company_id=" +
          company_data.company_id +
          "&" +
          url;
      }
    },
    getSummaryPdf(type) {
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      let url = parseParams(this.pageData);
      url = url + "&itemsPerPage=-1";
      if (this.pageData.filters["summery_of"] == "4") {
        window.location.href =
          process.env.VUE_APP_BASEURL +
          "/generate_get_profit_loss_data_final_pdf?is_pdf=true&user_id=" +
          localStorage.getItem("user_id") +
          "&company_id=" +
          company_data.company_id +
          "&type=" +
          type +
          "&" +
          url;
      } else {
        window.location.href =
          process.env.VUE_APP_BASEURL +
          "/transaction_summary_pdf?is_pdf=true&user_id=" +
          localStorage.getItem("user_id") +
          "&company_id=" +
          company_data.company_id +
          "&" +
          url;
      }
    },
    ChangeStartdate() {
      this.pagination.filters.date_filter = "8";
      this.pagination.filters.tran_start_date = this.change_start_date;
      this.pagination.filters.tran_end_date = this.change_end_date;
      this.changeDateFilter();
      this.getSummary(false);
      this.confirm_date_dialog = false;
    },
    CloseOpeningDialog() {
      this.pagination.filters.date_filter = "";
      this.confirm_date_dialog = false;
      this.pagination.filters.tran_start_date = "";
      this.pagination.filters.tran_end_date = "";
      this.changeDateFilter();
      // this.getSummary(false);
    },
    getSummary(isGenerateReport) {
      let _self = this;
      _self.loading = true;
      this.pageData.filters.expence_filter_flag = this.expence_filter_flag;
      let url = parseParams(this.pageData);
      if (isGenerateReport) {
        url = url + "&itemsPerPage=-1";
      }
      if (this.pagination.filters.summery_of == "4") {
        axios
          .get("get_profit_loss_data?" + url)
          .then(response => {
            if (_self.income_list.total != response.data.incomeData.total) {
              _self.pagination.page = 1;
            }
            _self.income_list = response.data.incomeData;
            _self.filter_start_date = response.data.start_date;
            _self.filter_start_end = response.data.end_date;
            _self.start_date_formate = response.data.start_date_formate;
            _self.end_date_formate = response.data.end_date_formate;
            _self.total_balance = response.data.balance;
            _self.total_credit = response.data.credit;
            _self.total_debit = response.data.debit;
            _self.per = response.data.per;
            _self.loading = false;
          })
          .catch(function() {
            _self.loading = false;
          });
      }

      if (
        ((this.pagination.filters.summery_of == "1" ||
          this.pagination.filters.summery_of == "3" ||
          this.pagination.filters.summery_of == "7") &&
          (this.pagination.filters.date_filter == "" ||
            this.pagination.filters.date_filter == "undefined" ||
            this.pagination.filters.date_filter == undefined)) ||
        this.pagination.filters.summery_of == "2"
      ) {
        this.getSummaryFinalData(url);
        // this.loading = false;
      }

      if (
        (this.pagination.filters.summery_of == "1" ||
          this.pagination.filters.summery_of == "3" ||
          this.pagination.filters.summery_of == "7") &&
        this.pagination.filters.date_filter != "" &&
        this.pagination.filters.date_filter != "undefined" &&
        this.pagination.filters.date_filter != undefined
      ) {
        this.getSummaryFinalData(url);
        // this.loading = false;
        // axios.get("get_out_of_date_data?page_list=report&" + url).then((response) => {
        // if(response.data.total>0){
        //   _self.outofdate_bank_list.data=response.data.data;
        //   _self.confirm_date_dialog=true;
        //   _self.change_start_date=response.data.start_date;
        //   _self.change_end_date=response.data.end_date;
        //   _self.actual_start_date=response.data.actual_start_date;
        // }else{
        //   this.getSummaryFinalData(url);
        // }
        // }).catch(function () {
        //     _self.loading = false;
        // });
      }
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel("Start new search, stop active search");
        // console.log('cancel request done');
      }
    },
    getSummaryFinalData(url) {
      let _self = this;
      _self.loading = true;
      _self.cancelSearch();
      _self.cancelSource = axios.CancelToken.source();
      axios
        .get("transaction_summary?" + url, {
          cancelToken: this.cancelSource.token
        })
        .then(response => {
          _self.items = response.data.data;
          _self.total_balance = response.data.total_balance;
          _self.total_credit = response.data.total_credit;
          _self.total_debit = response.data.total_debit;
          _self.filter_start_date = response.data.start_date;
          _self.filter_start_end = response.data.end_date;

          if (_self.pagination.filters.summery_of == "3") {
            _self.vendor_list = response.data.report_data.filter(function(
              item
            ) {
              return item.expence == "0";
            });
          } else if (_self.pagination.filters.summery_of == "7") {
            _self.expence_list = response.data.report_data.filter(function(
              item
            ) {
              return item.expence == "1";
            });
          } else {
            _self.project_bank_list = response.data.report_data;
          }

          _self.loading = false;
        })
        .catch(function() {
          // _self.loading = false;
        });
    },
    getSummaryExpense(isGenerateReport) {
      let _self = this;
      this.loading = true;
      this.pageData1.filters = this.pageData.filters;
      this.pageData1.filters.expence_filter_flag = this.expence_filter_flag;
      let url1 = parseParams(this.pageData1);
      if (isGenerateReport) {
        url1 = url1 + "&itemsPerPage=-1";
      }
      if (this.pageData.filters.summery_of == "4") {
        axios
          .get("get_profit_loss_data?" + url1)
          .then(response => {
            if (_self.expense_list.total != response.data.expenseData.total) {
              _self.pagination.page = 1;
            }
            _self.expense_list = response.data.expenseData;
            _self.filter_start_date = response.data.start_date;
            _self.filter_start_end = response.data.end_date;
            _self.start_date_formate = response.data.start_date_formate;
            _self.end_date_formate = response.data.end_date_formate;
            _self.total_balance = response.data.balance;
            _self.total_credit = response.data.credit;
            _self.total_debit = response.data.debit;
            _self.loading = false;
          })
          .catch(function() {
            _self.loading = false;
          });
      }
    },
    getVendorType() {
      let _self = this;
      // _self.loading = true;
      axios
        .get("vendor_type_list?itemsPerPage=-1")
        .then(response => {
          _self.vendor_type_list = response.data.data.data;
          // _self.loading = false;
        })
        .catch(function() {
          // _self.loading = false;
        });
    },
    RedirectLink(item) {
      if (this.pagination.filters.summery_of == "1") {
        return "/report/bank/" + item.content_id;
      } else if (this.pagination.filters.summery_of == "2") {
        return "/report/project/" + item.content_id + "/vendor";
      } else if (
        this.pagination.filters.summery_of == "3" ||
        this.pagination.filters.summery_of == "7"
      ) {
        if (item.expence) {
          return "/report/vendor/" + item.content_id + "/1";
        } else {
          return "/report/vendor/" + item.content_id + "/0";
        }
      }
    },
    openExcludedPopup() {
      if (this.pagination.filters.summery_of == "2") {
        this.exclude_for = "profit_loss";
      } else {
        this.exclude_for = "profit_loss";
      }
      this.exclude_report = true;
    },
    logout() {
      logout(this.$router);
    },

    excludeIncludeFromReport(status, data_for) {
      let _self = this;
      // _self.loading = true;
      let ids = [];
      _self.selectedRows.map(function(item) {
        ids.push(data_for == "project" ? item.project_id : item.content_id);
      });
      axios
        .post("exclude_include_from_report", {
          ids: ids,
          status: status,
          exclude_for: "profit_loss",
          data_for: data_for
        })
        .then(function(response) {
          if (data_for != "All") {
            _self.setAlert({
              show: true,
              variant: response.data.variant,
              message: response.data.message,
              dismissCountDown: 0
            });
            _self.getSummary(false);
          }
          // _self.loading = false;
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    },

    excludeIncludeFromProfitLossReport(status) {
      let _self = this;
      _self.loading = true;
      let ids = [];
      let customerIds = [];
      let projectIds = [];
      let expenseBankIds = [];
      let expenseVendorIds = [];

      _self.selectedIncomeRows.map(function(item) {
        ids.push(item.bank_id);
      });
      _self.selectedCustomerRows.map(function(item) {
        customerIds.push(item.customer_id);
      });
      _self.selectedProjectRows.map(function(item) {
        projectIds.push(item.project_id);
      });
      _self.selectedExpenseRows.map(function(item) {
        expenseBankIds.push(item.bank_id ? item.bank_id : item.vendor_bank_id);
      });
      _self.selectedVendorRows.map(function(item) {
        expenseVendorIds.push(item.vendor_id ? item.vendor_id : "");
      });

      axios
        .post("exclude_include_from_profit_loss_report", {
          ids: ids,
          customerIds: customerIds,
          projectIds: projectIds,
          expenseBankIds: expenseBankIds,
          expenseVendorIds: expenseVendorIds,
          status: status,
          exclude_for: _self.exclude_for
        })
        .then(function() {
          _self.getSummary(false);
          _self.getSummaryExpense(false);
          // _self.loading = false;
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    }
  },

  mounted() {
    this.getVendorType();
    this.excludeIncludeFromReport(1, "All");
    let report = localStorage.getItem("is_report_from_dashboard");
    if (report == true || report == "true") {
      resetDateFilterValue();
      this.resetFilter();
    } else {
      this.getSummary(false);
      this.getSummaryExpense(false);
    }
  }
};
</script>
<style>
/* .fix-table-header thead tr,
.fix-table-header tbody tr {
  min-width: 50%;
} */
</style>